// Locale files are nested per-section under `locales/{section}/{lang}.json`,
// so the auto-loader from `@intlify/unplugin-vue-i18n/messages` can't find
// them. Import them explicitly and merge into a single namespace per locale.
//
// Defining messages here (rather than via a runtime plugin that calls
// `$i18n.mergeLocaleMessage`) is critical: a plugin's order vs the
// `@nuxtjs/i18n` module plugin is non-deterministic, so user plugins that
// depend on `$i18n` can silently no-op on some clients and leave labels
// untranslated forever. `defineI18nConfig` is consumed by the module
// itself before any page renders, so no ordering question.
import appealsEn from './locales/appeals/en.json'
import appealsEl from './locales/appeals/el.json'
import applicationsEn from './locales/applications/en.json'
import applicationsEl from './locales/applications/el.json'
import applySubsidyEn from './locales/applySubsidy/en.json'
import applySubsidyEl from './locales/applySubsidy/el.json'
import asideEn from './locales/aside/en.json'
import asideEl from './locales/aside/el.json'
import authEn from './locales/auth/en.json'
import authEl from './locales/auth/el.json'
import commonEn from './locales/common/en.json'
import commonEl from './locales/common/el.json'
import headerEn from './locales/header/en.json'
import headerEl from './locales/header/el.json'
import homeEn from './locales/home/en.json'
import homeEl from './locales/home/el.json'
import layoutEn from './locales/layout/en.json'
import layoutEl from './locales/layout/el.json'
import notFoundEn from './locales/notFound/en.json'
import notFoundEl from './locales/notFound/el.json'
import paymentClaimEn from './locales/paymentClaim/en.json'
import paymentClaimEl from './locales/paymentClaim/el.json'
import profileEn from './locales/profile/en.json'
import profileEl from './locales/profile/el.json'
import seoEn from './locales/seo/en.json'
import seoEl from './locales/seo/el.json'
import subsidiesListEn from './locales/subsidiesList/en.json'
import subsidiesListEl from './locales/subsidiesList/el.json'
import switchAmeEn from './locales/switchAme/en.json'
import switchAmeEl from './locales/switchAme/el.json'
import userSatisfactionEn from './locales/userSatisfaction/en.json'
import userSatisfactionEl from './locales/userSatisfaction/el.json'
import supportEn from './locales/support/en.json'
import supportEl from './locales/support/el.json'
import accessibilityEn from './locales/accessibility/en.json'
import accessibilityEl from './locales/accessibility/el.json'
import cookiesEn from './locales/cookies/en.json'
import cookiesEl from './locales/cookies/el.json'
import privacyEn from './locales/privacy/en.json'
import privacyEl from './locales/privacy/el.json'
import authErrorEn from './locales/authError/en.json'
import authErrorEl from './locales/authError/el.json'
import confirmationEn from './locales/confirmation/en.json'
import confirmationEl from './locales/confirmation/el.json'
import notEligibleEn from './locales/notEligible/en.json'
import notEligibleEl from './locales/notEligible/el.json'

export default defineI18nConfig(() => ({
  messages: {
    en: {
      ...appealsEn,
      ...applicationsEn,
      ...applySubsidyEn,
      ...asideEn,
      ...authEn,
      ...commonEn,
      ...headerEn,
      ...homeEn,
      ...layoutEn,
      ...notFoundEn,
      ...paymentClaimEn,
      ...profileEn,
      ...seoEn,
      ...subsidiesListEn,
      ...switchAmeEn,
      ...userSatisfactionEn,
      ...supportEn,
      ...accessibilityEn,
      ...cookiesEn,
      ...privacyEn,
      ...authErrorEn,
      ...confirmationEn,
      ...notEligibleEn,
    },
    el: {
      ...appealsEl,
      ...applicationsEl,
      ...applySubsidyEl,
      ...asideEl,
      ...authEl,
      ...commonEl,
      ...headerEl,
      ...homeEl,
      ...layoutEl,
      ...notFoundEl,
      ...paymentClaimEl,
      ...profileEl,
      ...seoEl,
      ...subsidiesListEl,
      ...switchAmeEl,
      ...userSatisfactionEl,
      ...supportEl,
      ...accessibilityEl,
      ...cookiesEl,
      ...privacyEl,
      ...authErrorEl,
      ...confirmationEl,
      ...notEligibleEl,
    },
  },
}))
